
export { ShoppingBagButton } from "/codebuild/output/src187247037/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"